const factory = (ClientRequest, Collection) => {
  class ClientRequestCollection extends Collection {
    $init() {
      if (this.$lastUpdated === 0) {
        this.$fetch();
      }
    }

    $url() {
      return `${this.$resource}.json/client/${this.clientId}/requests`;
    }

    $fetch() {
      super.$fetch().then(({ data: { total, completed } }) => this.$set({ total, completed }));
    }

    $post(request) {
      const newRequest = new ClientRequest({ clientId: this.clientId });

      return newRequest.$post(request).then(data => {
        newRequest.$destroy();
        return this.$add({ clientId: this.clientId, ...data });
      });
    }

    $serialize(data) {
      if (!data.requests) {
        return super.$serialize(data);
      }

      return data.requests.map(request => ({ clientId: this.clientId, ...request }));
    }

    $getCompleted() {
      return this.$data().filter(request => request.status === 'COMPLETED');
    }

    $getActive() {
      return this.$data().filter(request => request.status !== 'COMPLETED');
    }
  }

  ClientRequestCollection.prototype.$resource = 'clientrequest';
  ClientRequestCollection.prototype.$type = ClientRequest;
  ClientRequestCollection.prototype.$idName = 'clientId';
  ClientRequestCollection.prototype.$$cacheModels = true;

  return ClientRequestCollection;
};

const moduleDeps = [require('data/model/clientRequest').name, require('data/util').name];

module.exports = angular
  .module('bench.data.collection.clientRequest', moduleDeps)
  .factory('ClientRequestCollection', factory);
